import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  gap: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  flex-direction: row;
  margin: 0;
  padding: 0;
`;

export const ChatArea = styled.div`
  width: ${(props) => props.$isExpanded ? '50%' : '20%'};
  min-width: 250px;
  max-width: ${(props) => props.$isExpanded ? '800px' : '350px'};
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.background || '#FFFFFF'};
  border-right: 1px solid ${(props) => props.theme.colors.border || '#E5E7EB'};
  transition: width 0.3s ease, max-width 0.3s ease;
  overflow: hidden;
  order: 1;
  flex-shrink: 0;
`;

export const CanvasArea = styled.div`
  width: ${(props) => props.$chatExpanded ? '50%' : '80%'};
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.colors.background || '#FFFFFF'};
  transition: width 0.3s ease;
  overflow: hidden;
  order: 2;
  margin: 0;
  padding: 0;
`;

export const ChatExpandButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 6px;
  background: ${(props) => props.theme.colors.backgroundSecondary || '#F9FAFB'};
  border: 1px solid ${(props) => props.theme.colors.border || '#E5E7EB'};
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  z-index: 10;

  &:hover {
    background: ${(props) => props.theme.colors.border || '#E5E7EB'};
    border-color: ${(props) => props.theme.colors.text || '#374151'};
  }

  svg {
    font-size: 18px;
    color: ${(props) => props.theme.colors.text || '#374151'};
  }
`;

export const ChatMessagesContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  position: relative;
  
  /* Custom scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.border || '#D1D5DB'};
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.textSecondary || '#9CA3AF'};
  }
`;

export const ChatInputContainer = styled.div`
  padding: 12px;
  border-top: 1px solid ${(props) => props.theme.colors.border || '#E5E7EB'};
  background: ${(props) => props.theme.colors.background || '#FFFFFF'};
  flex-shrink: 0;
`;

